import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: {
    id: 'settings.pageTitle',
    defaultMessage: 'Settings'
  },
  firstName: {
    id: 'settings.firstName',
    defaultMessage: 'First Name'
  },
  lastName: {
    id: 'settings.lastName',
    defaultMessage: 'Last Name'
  },
  phone: {
    id: 'settings.phone',
    defaultMessage: 'Phone'
  },
  address: {
    id: 'settings.address',
    defaultMessage: 'Address'
  },
  city: {
    id: 'settings.city',
    defaultMessage: 'City'
  },
  gender: {
    id: 'settings.gender',
    defaultMessage: 'Gender'
  },
  genderMale: {
    id: 'settings.genderMale',
    defaultMessage: 'Male'
  },
  genderFemale: {
    id: 'settings.genderFemale',
    defaultMessage: 'Female'
  },
  visitPrice: {
    id: 'settings.visitPrice',
    defaultMessage: 'Visit Price'
  },
  followUpPrice: {
    id: 'settings.followUpPrice',
    defaultMessage: 'Follow Up Price'
  },
  saveProfile: {
    id: 'settings.saveProfile',
    defaultMessage: 'Save profile'
  },
  saveSuccess: {
    id: 'settings.saveSuccess',
    defaultMessage: 'Your profile has been successfully updated.'
  },
  saveError: {
    id: 'settings.saveError',
    defaultMessage: 'Something went wrong, please try again later'
  }
})
